module["exports"] = [
  "Công ty",
  "Cty TNHH",
  "Cty",
  "Cửa hàng",
  "Trung tâm",
  "Chi nhánh"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/company/prefix.js
 ** module id = 1095
 ** module chunks = 0
 **/